<template>
  <popup-dialog @close="close" :z-index="2000" v-if="visible">
    <div class="login-chinese">
      <div class="login-chinese-logo">
        <img src="~@/assets/chinese_logo.png" alt="CF40 RESEARCH" />
      </div>
      <div class="login-chinese-content">
        <div class="login-chinese-content-tab">
          <div :class="{ 'login-chinese-content-tab-cell': true, 'active': selectTab == 'account' }" @click="tabChange('account')">账户</div>
          <div :class="{ 'login-chinese-content-tab-cell': true, 'active': selectTab == 'scan' }" @click="tabChange('scan')">扫码</div>
        </div>
        <div class="login-chinese-content-form" v-if="selectTab == 'account'">
          <el-form ref="subForm" :model="subForm" size="default" :rules="rules" :label-width="isMobile() ? '0px' : '80px'">
            <el-form-item :label="isMobile() ? '' : '账户'" prop="username" v-if="type == 'login'">
              <el-input v-model="subForm.username" placeholder="请输入邮箱" @keyup.native.enter="operate" clearable></el-input>
            </el-form-item>
            <el-form-item :label="isMobile() ? '' : '邮箱'" prop="email" v-if="type == 'register' || type == 'forgot'">
              <el-input v-model="subForm.email" placeholder="请输入邮箱地址" @keyup.native.enter="operate" clearable></el-input>
            </el-form-item>
            <el-form-item :label="isMobile() ? '' : '密码'" prop="password">
              <el-input v-model="subForm.password" type="password" placeholder="请输入密码" @keyup.native.enter="operate" clearable></el-input>
            </el-form-item>
            <el-form-item :label="isMobile() ? '' : '确认密码'" prop="checkPass" v-if="type == 'register' || type == 'forgot'">
              <el-input v-model="subForm.checkPass" type="password" placeholder="请再次输入密码" @keyup.native.enter="operate" clearable></el-input>
            </el-form-item>
            <el-form-item :label="isMobile() ? '' : '验证码'" prop="code" v-if="type == 'register' || type == 'forgot'">
              <div class="code-row">
                <el-input v-model="subForm.code" placeholder="请输入邮箱验证码" @keyup.native.enter="operate" clearable></el-input>
                <el-button class="get-code" :loading="codeLoading" :disabled="countdown > 0" @click="getVeriCode">
                  {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item v-if="type == 'login' || type == 'register'">
              <login-consent v-model="agreementsAccepted" @open="openProtocol" />
            </el-form-item>
            <el-form-item>
              <el-button class="submit" :loading="loading" @click="operate">
                <span v-if="type == 'login'">登录</span>
                <span v-else-if="type == 'register'">注册</span>
                <span v-else-if="type == 'forgot'">重置密码</span>
              </el-button>
            </el-form-item>
            <template v-if="type == 'login'">
              <el-form-item>
                <div class="flex-row">
                  <div class="forgot-pass" @click="typeChange('forgot')">
                    忘记密码？点击找回
                  </div>
                  <div class="register" @click="typeChange('register')">
                    注册
                  </div>
                </div>
              </el-form-item>
            </template>
            <template v-else-if="type == 'register'">
              <el-form-item>
                <div class="flex-row">
                  <div class="forgot-pass no-link"></div>
                  <div class="register" @click="typeChange('login')">
                    已经有一个账户？登录
                  </div>
                </div>
              </el-form-item>
            </template>
            <template v-else-if="type == 'forgot'">
              <el-form-item>
                <div class="flex-row">
                  <div class="forgot-pass"></div>
                  <div class="register" @click="typeChange('login')">
                    登录
                  </div>
                </div>
              </el-form-item>
            </template>
          </el-form>
        </div>
        <div class="login-chinese-content-qrcode" v-else>
          <div v-if="agreementsAccepted" class="login-chinese-content-qrcode-icon" v-loading="loading">
            <el-image :src="qrcode.qr_code" lazy style="width: 300px; height: 300px"></el-image>
          </div>
          <login-consent v-model="agreementsAccepted" @input="scanConsentChange" @open="openProtocol" />
          <p class="scan-consent-hint">阅读并勾选后显示二维码</p>
        </div>
      </div>
    </div>
    <service-agreement ref="serviceAgreementRef"></service-agreement>
  </popup-dialog>
</template>

<script>
import PopupDialog from "../popupDialog";
import ServiceAgreement from "@/components/serviceAgreement";
import LoginConsent from "@/components/loginConsent";
import { appletQR, testLogin, loginSystem, registerSystem, sendRegisterCode, forgotPassword, sendForgotCode, initConfig } from "@/api";
import { showInitialPasswordNotice } from "@/utils/initialPasswordNotice";
export default {
  name: "LoginChinese",
  components: {
    PopupDialog,
    ServiceAgreement,
    LoginConsent
  },
  data() {
    return {
      visible: false,
      agreementsAccepted: false,
      loading: false,
      codeLoading: false,
      protocolLoading: false,
      type: "login",
      selectTab: "account",
      subForm: {},
      rules: {
        username: [
          { required: true, message: "请输入登录账号信息", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: ["blur", "change"] }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 16, message: "密码的长度在6到16位之间", trigger: "blur" }
        ],
        checkPass: [
          { validator: this.validatePassword, trigger: 'blur' }
        ],
        code: [
          { required: true, message: "请输入邮箱验证码", trigger: "blur" }
        ]
      },
      qrcode: {
        qr_code: "",
        validateToken: "",
        qrTimer: null,
        testTimer: null
      },
      countdown: 0,
      codeTimer: null,
    };
  },
  methods: {
    // 打开窗口
    open() {
      this.type = "login";
      this.agreementsAccepted = false;
      this.selectTab = "account";
      this.subForm = {
        username: "",
        email: "",
        password: "",
        checkPass: "",
        code: "",
        token: ""
      };
      this.qrcode = {
        qr_code: "",
        validateToken: "",
        qrTimer: null,
        testTimer: null
      }
      this.visible = true;
    },
    // 关闭窗口
    close () {
      clearInterval(this.qrcode.testTimer);
      clearInterval(this.qrcode.qrTimer);
      this.visible = false;
    },
    validatePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.subForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    typeChange(e) {
      this.type = e;
      this.agreementsAccepted = false;
      this.subForm = {
        username: "",
        email: "",
        password: "",
        checkPass: "",
        code: "",
        token: ""
      };
      this.countdown = 0;
      this.codeTimer = null;
    },
    tabChange(e) {
      if (e == 'scan' && this.agreementsAccepted) {
        this.refreshQr();
      } else {
        clearInterval(this.qrcode.testTimer);
        clearInterval(this.qrcode.qrTimer);
      }
      this.selectTab = e;
    },
    scanConsentChange(accepted) {
      clearInterval(this.qrcode.testTimer);
      clearInterval(this.qrcode.qrTimer);
      this.qrcode.qr_code = "";
      if (accepted && this.selectTab == 'scan') this.refreshQr();
    },
    refreshQr() {
      clearInterval(this.qrcode.testTimer);
      clearInterval(this.qrcode.qrTimer);
      let _This = this;
      this.getQrCode();
      this.qrcode.qrTimer = setInterval(function() {
        _This.getQrCode();
      }, 300000);
    },
    async getQrCode() {
      let _This = this;
      this.loading = true;
      let res = await appletQR();
      if (!this.visible || this.selectTab != 'scan' || !this.agreementsAccepted) {
        this.loading = false;
        return;
      }
      if (res && res.code == 200) {
        this.qrcode.qr_code = `data:image/png;base64,${res.data.data}`;
        this.qrcode.validateToken = res.data.stoken;
        this.qrcode.testTimer = setInterval(function() {
          _This.detectLogin();
        }, 1000);
      }
      this.loading = false;
    },
    async detectLogin() {
      let res = await testLogin({ stoken: this.qrcode.validateToken });
      if (!this.visible || this.selectTab != 'scan' || !this.agreementsAccepted) return;
      if (res && res.code == 200) {
        if (res.data && res.data.token) {
          localStorage.setItem("cf40-token", res.data.token);
          this.$emit("success");
          this.close();
        }
      } else {
        clearInterval(this.qrcode.testTimer);
        clearInterval(this.qrcode.qrTimer);
        this.refreshQr();
      }
    },

    async loginHandle() {
      if (this.loading) return;
      if (!this.agreementsAccepted) {
        this.$message.warning('请先阅读并同意《会员服务协议》和《隐私政策》');
        return;
      }
      this.loading = true;
      try {
        const param = {
          username: this.subForm.username.replace(/\s/g, ''),
          password: this.subForm.password,
        };
        const res = await loginSystem(param);
        if (res && res.code == 200 && res.data && res.data.token) {
          localStorage.setItem("cf40-token", res.data.token);
          this.close();
          this.$message.success("登录成功");
          await showInitialPasswordNotice(this, res.data);
          this.$emit("success");
        }
      } catch (error) {
        // 请求层统一显示登录和网络错误。
      } finally {
        this.loading = false;
      }
    },
    async registerHandle() {
      if (this.loading) return;
      if (!this.agreementsAccepted) {
        this.$message.warning('请先阅读并同意《会员服务协议》和《隐私政策》');
        return;
      }
      this.loading = true;
      let param = {
        email: this.subForm.email.replace(/\s/g, ''),
        password: this.subForm.password,
        code: this.subForm.code,
      };
      let res = await registerSystem(param);
      if (res && res.code == 200) {
        if (res.data && res.data.token) {
          localStorage.setItem("cf40-token", res.data.token);
          this.$emit("success");
          this.close();
          this.$message.success("注册成功");
        }
      }
      this.loading = false;
    },
    async forgotHandle() {
      this.loading = true;
      let param = {
        password: this.subForm.password,
        code: this.subForm.code,
        token: this.subForm.token
      };
      let res = await forgotPassword(param);
      if (res && res.code == 200) {
        this.type = "login";
        this.$message.success(res.msg ? res.msg : "重置密码成功");
      }
      this.loading = false;
    },
    async registerCode() {
      this.codeLoading = true;
      let param = {
        email: this.subForm.email.replace(/\s/g, '')
      };
      let _This = this;
      if (!_This.codeTimer) {
        let res = await sendRegisterCode(param);
        if (res && res.code == 200) {
          this.$message.success(res.msg ? res.msg : '验证码发送成功');
          _This.countdown = 60;
          _This.codeTimer = setInterval(() => {
            _This.countdown--;
            if (_This.countdown <= 0) {
              clearInterval(_This.codeTimer);
              _This.codeTimer = null;
            }
          }, 1000);
        }
      }
      this.codeLoading = false;
    },
    async forgotCode() {
      this.codeLoading = true;
      let param = {
        email: this.subForm.email
      };
      let _This = this;
      if (!_This.codeTimer) {
        let res = await sendForgotCode(param);
        if (res && res.code == 200) {
          if (res.data && res.data.token) {
            this.subForm.token = res.data.token;
            this.$message.success(res.msg ? res.msg : '验证码发送成功');
            _This.countdown = 60;
            _This.codeTimer = setInterval(() => {
              _This.countdown--;
              if (_This.countdown <= 0) {
                clearInterval(_This.codeTimer);
                _This.codeTimer = null;
              }
            }, 1000);
          }
        }
      }
      this.codeLoading = false;
    },
    async openProtocol(name, key) {
      if (this.protocolLoading) return;
      this.protocolLoading = true;
      try {
        const res = await initConfig();
        const agreement = res && res.code == 200 && Array.isArray(res.data)
          ? res.data.find(item => item.config_key == key)
          : null;
        if (agreement && agreement.config_value && agreement.config_value.trim() && this.$refs.serviceAgreementRef) {
          this.$refs.serviceAgreementRef.open(name, agreement.config_value);
        } else if (this.visible) {
          this.$message.warning('协议暂时无法加载，请稍后重试');
        }
      } catch (error) {
        if (this.visible) this.$message.warning('协议暂时无法加载，请稍后重试');
      } finally {
        this.protocolLoading = false;
      }
    },
    getVeriCode() {
      this.$refs.subForm.validateField('email', (valid) => {
        if (!valid) {
          if (this.type == "register") {
            this.registerCode();
          } else if (this.type == "forgot") {
            this.forgotCode();
          }
        }
      });
    },
    operate() {
      this.$refs.subForm.validate((valid) => {
        if (valid) {
          if (this.type == 'login') {
            this.loginHandle();
          } else if (this.type == 'register') {
            this.registerHandle();
          } else if (this.type == 'forgot') {
            this.forgotHandle();
          }
        }
      });
    },
    isMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'ipod', 'windows phone'];
      return mobileKeywords.some(keyword => userAgent.includes(keyword));
    },
  }
}
</script>
<style lang="scss" scoped>
.login-chinese {
  .code-row {
    display: flex;
    gap: 8px;
    align-items: center;
    .el-input {
      flex: 1;
      min-width: 0;
    }
    .get-code {
      flex: none;
      margin: 0;
      padding: 12px 10px;
      font-size: 14px;
      white-space: nowrap;
      color: #ffffff;
      border-color: #ed6f33;
      background-color: #ed6f33;
      &:hover, &:focus, &.is-disabled {
        color: #ffffff;
        border-color: #fa996b;
        background-color: #fa996b;
      }
    }
  }
  display: flex;
  align-items: center;
  &-logo {
    max-width: 280px;
    margin-left: 50px;
    margin-right: 30px;
  }
  &-content {
    flex: 1;
    min-width: 0;
    margin-left: 30px;
    &-tab {
      display: flex;
      justify-content: center;
      align-items: center;
      &-cell {
        position: relative;
        cursor: pointer;
        user-select: none;
        font-size: 18px;
        margin-left: 50px;
        &:hover, &.active {
          font-family: HarmonyOS_Bold;
          &:after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -10px;
            width: 100%;
            height: 2px;
            background: #ed6f33;
          }
        }
        &:first-child {
          margin-left: 0;
        }
      }
    }
    &-form {
      margin-top: 30px;
      margin-bottom: 50px;
      .submit {
        width: 100%;
        padding: 10px 30px;
        font-size: 16px;
        font-family: HarmonyOS_Bold;
        color: #ffffff;
        background-color: #ed6f33;
        &:hover {
          color: #ffffff;
          border-color: #fa996b;
          background-color: #fa996b;
        }
        &:active {
          border-color: #ed6f33;
          background-color: #ed6f33;
        }
      }
      .flex-row {
        display: flex;
        justify-content: space-between;
        .forgot-pass, .register {
          cursor: pointer;
          user-select: none;
          font-family: HarmonyOS_Bold;
          &:hover {
            color: #ed6f33;
          }
          &.no-link {
            cursor: auto;
            &:hover {
              color: inherit;
            }
          }
        }
      }
      ::v-deep {
        .el-alert__content {
          line-height: 22px!important;
        }
        .el-form-item__label {
          color: inherit;
          font-size: 16px;
        }
        .el-input__inner {
          &:focus {
            border-color: #ed6f33;
          }
        }
      }
      .tip-accord {
        font-size: 12px;
        line-height: 20px;
        .text-link {
          cursor: pointer;
          color: #ed6f33;
        }
      }
    }
    &-qrcode {
      margin: 50px 0 20px 0;
      text-align: center;
      .scan-consent-hint {
        margin: 8px 0 0;
        color: #909399;
        font-size: 12px;
        line-height: 20px;
      }
      &-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .login-chinese {

  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .login-chinese {
    flex-direction: column;
    &-logo {
      max-width: 230px;
      margin: 15px 0 0 0;
    }
    &-content {
      width: 100%;
      margin-left: 0;
      margin-top: 15px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .login-chinese .code-row {
    flex-wrap: wrap;
    .el-input {
      flex-basis: 100%;
    }
  }
}
</style>
